import { createSlice } from "@reduxjs/toolkit";
import { nodeList } from "../../actions/controlPanel/nodeList";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const nodeListReducer = createSlice({
  name: "nodeList",
  initialState,
  reducers: {
    // clearnodeList: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(nodeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(nodeList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(nodeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { clearnodeList } = getCategoriessSlice.actions;
export default nodeListReducer.reducer;
